<template>
  <div class="main-content signup-login-container">
    <div class="container">
      <div class="row justify-content-center">
        <a
          href="/"
          class="col-12 d-center-center pt-5"
          v-if="isProfileCompletion"
        >
          <img
            class="img-fluid brand-img"
            src="/img/brand/FullLogoColored-01.png"
            alt=""
          />
        </a>
        <div
          :class="`col-lg-${isProfileCompletion ? '12' : '6'} col-md-${
            isProfileCompletion ? '7' : '12'
          }`"
          v-if="isProfileCompletion"
        >
          <router-view></router-view>
        </div>
        <div class="login-wrapper" v-else>
          <router-view></router-view>
        </div>
      </div>
      <login-footer />
    </div>
  </div>
</template>
<script>
export default {
  name: "auth-layout",
  data() {
    const storedStep = localStorage.getItem("profileStep")
    const step = storedStep ? Number(storedStep) : null
    const isProfileCompletion = this.$route.path.includes("complete-profile")
    return {
      step,
      isProfileCompletion,
    }
  },
  created () {
    this.$store.dispatch("fetchCategories")
  },
  watch: {
    $route: {
      handler(route) {
        if (this.isProfileCompletion && route.path.includes("login")) {
          this.$router.push("/complete-profile")
        }
        this.isProfileCompletion = route.path.includes("complete-profile")
      },
      immediate: true,
    },
  },
}
</script>
<style>
.brand-img {
  width: 280px;
}
.login-wrapper {
  display: flex;
  width: 400px !important;
  max-width: 400px !important;
  padding: 32px 32px 40px 32px;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  border-radius: 12px;
  background: var(--White, #fff);
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.2);
}
</style>
